// 📄 cloudConfigService.ts
// Sub-fase K5 (refactor de Configuraciones Cloud/On-Premise): un único doc
// por proyecto con Scopes Habilitados + Acceso al Tenant. `credencialAdminId`
// es solo una REFERENCIA a projects/{id}/credenciales/{credId} — la
// contraseña en sí nunca vive acá, sigue viviendo únicamente en el vault
// (Secret Manager vía credentialManager, ver credentialService.ts).
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export interface CloudConfigData {
  scopesHabilitados: string[];
  tenantUrl: string;
  whitelistIps: string[];
  credencialAdminId: string; // "" si no hay ninguna asignada
}

const cloudConfigRef = (projectId: string) => doc(db, "projects", projectId, "cloudConfig", "general");

export const emptyCloudConfig = (): CloudConfigData => ({
  scopesHabilitados: [],
  tenantUrl: "",
  whitelistIps: [],
  credencialAdminId: ""
});

export const getCloudConfig = async (projectId: string): Promise<CloudConfigData> => {
  const snap = await getDoc(cloudConfigRef(projectId));
  if (!snap.exists()) return emptyCloudConfig();
  const data = snap.data();
  return {
    scopesHabilitados: data.scopesHabilitados || [],
    tenantUrl: data.tenantUrl || "",
    whitelistIps: data.whitelistIps || [],
    credencialAdminId: data.credencialAdminId || ""
  };
};

export const saveCloudConfig = async (projectId: string, data: CloudConfigData): Promise<void> => {
  await setDoc(cloudConfigRef(projectId), { ...data, actualizadoEn: serverTimestamp() }, { merge: true });
};
